import React from "react";
import {
  EligiblePayPeriodDetermination,
  EmployerContributionType,
  GetContributionType,
  GetRetirementDateRule,
  NonPayPeriodYesandNo,
} from "../../utils/constants/NonPayPeriod";

const NonPayPeriodReportSliderForm = ({
  allSources,
  retirementAge,
  sourcesApiData,
  isGenerateReportEnabled,
}) => {
  const discretionarySource = allSources?.employerDiscretionarySource;
  const matchSource = allSources?.employerMatchSource;
  const sourceCategory = allSources?.sourceCategory;
  return (
    <div>
      {isGenerateReportEnabled ? (
        <>
          <div className="horizontal-nPayPeriod" />
          <div>
            <h6 className="mt-3 mb-20">Plan Default Configurations</h6>

            {(sourceCategory == 5 || sourceCategory == 8) &&
              discretionarySource?.eligiblePaymentType != 0 && (
                <>
                  <p className="header-nPayPeriod">
                    Eligible pay determination based on
                  </p>

                  <p>
                    {EligiblePayPeriodDetermination(
                      discretionarySource?.eligiblePaymentType
                    ) ?? "-"}
                  </p>
                </>
              )}

            {(sourceCategory == 6 || sourceCategory == 7) &&
              matchSource?.eligiblePaymentType != 0 && (
                <>
                  <p className="header-nPayPeriod">
                    Eligible pay determination based on
                  </p>
                  <p>
                    {EligiblePayPeriodDetermination(
                      matchSource?.eligiblePaymentType
                    ) ?? "-"}
                  </p>
                </>
              )}

            {(sourceCategory == 5 || sourceCategory == 8) && (
              <>
                <div>
                  <p className="header-nPayPeriod">
                    Employer contribution type
                  </p>
                  <p className="fw-500">
                    {EmployerContributionType(
                      discretionarySource?.employerContributionType
                    )}
                  </p>
                </div>

                <div>
                  <p className="header-nPayPeriod">
                    Percentage of compensation
                  </p>
                  <p className="fw-500">
                    {discretionarySource?.percentageOfCompensation ?? 0}%
                  </p>
                </div>

                <div>
                  <p className="header-nPayPeriod">
                    Include plan compensation earned pre-match entry
                  </p>
                  <p>
                    {NonPayPeriodYesandNo(
                      discretionarySource?.isIncludePlanCompensation
                    )}
                  </p>
                </div>
              </>
            )}

            {(sourceCategory == 6 || sourceCategory == 7) && (
              <>
                <div>
                  <p className="header-nPayPeriod">Source of match </p>
                  <p className="fw-500">
                    {sourcesApiData?.length != 0 ? sourcesApiData : "-"}
                  </p>
                </div>

                {matchSource?.responsibleMode != 1 && (
                  <div>
                    <p className="header-nPayPeriod">Catchup applicable</p>
                    <p className="fw-500">
                      {NonPayPeriodYesandNo(matchSource?.isCatchApplicable)}
                    </p>
                  </div>
                )}

                <div>
                  <p className="header-nPayPeriod">
                    Employer contribution type{" "}
                  </p>
                  <p>
                    {GetContributionType(
                      matchSource?.employerContributionType,
                      matchSource?.isSafeHarbourMatch,
                      matchSource?.safeHarbourType
                    )}
                  </p>
                </div>

                {matchSource?.employerContributionType == 2 && (
                  <>
                    <p className="header-nPayPeriod">Match percent</p>
                    <p className="fw-500">
                      {matchSource?.percentageOfCalculation}%
                    </p>

                    <p className="header-nPayPeriod">
                      {" "}
                      Percent of compensation matched
                    </p>
                    <p className="fw-500">
                      {matchSource?.percentageOfCompensation}%
                    </p>
                  </>
                )}
                {matchSource?.isSafeHarbourMatch &&
                  matchSource?.safeHarbourType == 3 && (
                    <>
                      <p className="header-nPayPeriod">
                        Enhanced Match Percentage
                      </p>
                      <p className="fw-500">
                        {matchSource?.enhancedshMatchPercentage}%
                      </p>

                      <p className="header-nPayPeriod">
                        {" "}
                        Upto Percentage Of Deferral
                      </p>
                      <p className="fw-500">
                        {matchSource?.uptoPercentageOfDeferral}%
                      </p>
                    </>
                  )}

                {(matchSource?.employerContributionType == 3 ||
                  (matchSource?.isSafeHarbourMatch &&
                    (matchSource?.safeHarbourType == 1 ||
                      matchSource?.safeHarbourType == 2))) && (
                  <>
                    <p className="header-nPayPeriod">Tier#1 match percent</p>
                    <p className="fw-500">
                      {matchSource?.firstTierMatchPercent}%
                    </p>

                    <p className="header-nPayPeriod">
                      Tier#1 percentage of compensation matched{" "}
                    </p>
                    <p className="fw-500">
                      {matchSource.firstTierCompensationMatchPercent}%
                    </p>

                    <p className="header-nPayPeriod">Tier#2 match percent</p>
                    <p className="fw-500">
                      {matchSource.secondTierMatchPercent}%
                    </p>

                    <p className="header-nPayPeriod">
                      Tier#2 percentage of compensation matched
                    </p>
                    <p className="fw-500">
                      {matchSource.secondTierCompensationMatchPercent}%
                    </p>

                    <p className="header-nPayPeriod">Tier#3 match percent</p>
                    <p className="fw-500">
                      {matchSource.thirdTierMatchPercent}%
                    </p>

                    <p className="header-nPayPeriod">
                      Tier#3 percentage of compensation matched
                    </p>
                    <p className="fw-500">
                      {matchSource.thirdTierCompensationMatchPercent}%
                    </p>
                  </>
                )}

                <div>
                  <p className="header-nPayPeriod">
                    Include deferrals made to the plan pre-match entry
                  </p>
                  <p>{NonPayPeriodYesandNo(matchSource?.isIncludeDefferals)}</p>
                </div>

                <div>
                  <p className="header-nPayPeriod">
                    Include plan compensation earned pre-match entry
                  </p>
                  <p className="fw-500">
                    {NonPayPeriodYesandNo(
                      matchSource?.isIncludePlanCompensation
                    )}
                  </p>
                </div>
              </>
            )}

            <div>
              <p className="header-nPayPeriod">Last day rule</p>
              <p className="fw-500">
                {NonPayPeriodYesandNo(
                  sourceCategory == 6 || sourceCategory == 7
                    ? matchSource?.isLastDayRule
                    : discretionarySource?.isLastDayRule
                )}
              </p>
            </div>
            <div>
              <p className="header-nPayPeriod">Hours requirement</p>
              <p className="fw-500">
                {NonPayPeriodYesandNo(
                  sourceCategory == 6 || sourceCategory == 7
                    ? matchSource?.isHoursRequirement
                    : discretionarySource?.isHoursRequirement
                )}
              </p>
            </div>

            {(matchSource?.isLastDayRule ||
              matchSource?.isHoursRequirement ||
              discretionarySource?.isLastDayRule ||
              discretionarySource?.isHoursRequirement) && (
              <>
                {(discretionarySource?.isHoursRequirement ||
                  matchSource?.isHoursRequirement) && (
                  <div>
                    <p className="header-nPayPeriod">Hours</p>
                    <p className="fw-500">
                      {sourceCategory === 6 || sourceCategory === 7
                        ? matchSource?.hours
                        : discretionarySource?.hours}{" "}
                      hours
                    </p>
                  </div>
                )}

                {/* <div>
                  <p className="header-nPayPeriod">Normal retirement</p>
                  <p className="fw-500">
                    {NonPayPeriodYesandNo(
                      sourceCategory == 6 || sourceCategory == 7
                        ? matchSource?.isNormalRetirement
                        : discretionarySource?.isNormalRetirement
                    )}
                  </p>
                </div>

                <div>
                  <p className="header-nPayPeriod">Normal retirement age</p>
                  {matchSource?.isNormalRetirement ||
                  discretionarySource?.isNormalRetirement ? (
                    <p className="fw-500">
                      {retirementAge?.normalAgeYears ||
                      retirementAge?.normalAgeMonths
                        ? `${retirementAge?.normalAgeYears} years${
                            retirementAge?.normalAgeMonths
                              ? ` ${retirementAge.normalAgeMonths} months`
                              : ""
                          } and ${GetRetirementDateRule(
                            retirementAge?.normalRetirementDateRule
                          )}`
                        : "-"}
                    </p>
                  ) : (
                    "-"
                  )}
                </div>
                <div>
                  <p className="header-nPayPeriod">Early retirement</p>
                  <p className="fw-500">
                    {NonPayPeriodYesandNo(
                      sourceCategory == 6 || sourceCategory == 7
                        ? matchSource?.isEarlyRetirement
                        : discretionarySource?.isEarlyRetirement
                    )}
                  </p>
                </div>

                <div>
                  <p className="header-nPayPeriod">Early retirement age</p>
                  {matchSource?.isEarlyRetirement ||
                  discretionarySource?.isEarlyRetirement ? (
                    <p className="fw-500">
                      {retirementAge?.earlyAgeYears ||
                      retirementAge?.earlyAgeMonths
                        ? `${retirementAge?.earlyAgeYears} years${
                            retirementAge?.earlyAgeMonths
                              ? ` ${retirementAge.earlyAgeMonths} months`
                              : ""
                          } and ${GetRetirementDateRule(
                            retirementAge?.earlyRetirementDateRule
                          )}`
                        : "-"}
                    </p>
                  ) : (
                    "-"
                  )}
                </div> */}
                <div>
                  <p className="header-nPayPeriod">Death</p>
                  <p className="fw-500">
                    {sourceCategory === 6 || sourceCategory === 7
                      ? NonPayPeriodYesandNo(matchSource?.isDeath)
                      : NonPayPeriodYesandNo(discretionarySource?.isDeath)}
                  </p>
                </div>

                <div>
                  <p className="header-nPayPeriod">Disability</p>
                  <p className="fw-500">
                    {NonPayPeriodYesandNo(
                      sourceCategory == 6 || sourceCategory == 7
                        ? matchSource?.isDisability
                        : discretionarySource?.isDisability
                    )}
                  </p>
                </div>
              </>
            )}
          </div>
        </>
      ) : null}
    </div>
  );
};

export default NonPayPeriodReportSliderForm;
